import Button from "../../../common/Button";
import ReactDOM from "react-dom";
import Backdrop from "../../../common/modal/Backdrop";
import Modal from "../../../common/Modal";
import ModalInnerWrapper from "../../../common/ModalInnerWrapper";
import PannelBody from "../../../fragments/PannelBody";
import TextareaBox from "../../../common/interactive/TextareaBox";
import { useState } from "react";
import InputBox from "../../../common/interactive/InputBox";
import { addVerificationLiability, addVerificationMajorMed, addVerificationMedPayPipUm, caseQuickUpdate } from "../../../../lib/fetchApi";
import { useDispatch, useSelector } from "react-redux";
import { notificationActions } from "../../../../store/notifications";
import { caseActions } from "../../../../store/case";
import CheckboxCell from "../../../common/interactive/CheckboxCell";
import GlobalTooltip from "../../../common/GlobalTooltip";
import { formatDate } from "../../../../lib/script";
import { verificationStatusOptions } from "../../../../lib/systemData";
import CustomSelect from "../../../common/interactive/CustomSelect";


// Major meds does not have a claim number  

export default function AddVerification({itemId, folder, verificationField, mpPipUmType, caseType}) {
    const [isModalOpened, setIsModalOpened] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isComplete, setIsComplete] = useState(false);

    const [errorMessage, setErrorMessage] = useState(null)

    const dispatch = useDispatch()
    const activeCase = useSelector(state => state.case.activeCase)  
    const userToken = useSelector(state => state.user.token)
    const user = useSelector(state => state.user.user)

    function addVerificationHandler() {
        setIsModalOpened(prevState => prevState = !prevState);
        setIsComplete(false)
    }

    async function addVerification(event) {
        event.preventDefault();
        setIsLoading(true);

        try {
            const fd = new FormData(event.target)

            const formData = Object.fromEntries(fd.entries())

            let reqBody = {
                spoke_to: formData.spoke_to,
                notes: formData.resolve_notes,
                status: formData.status,
            }

            if (!formData.status) {
                setErrorMessage(`Status is required`)
                return
            }
            
            let data

            let completeVerifyData = reqBody   
            
            if (folder != 'major_meds') {
                completeVerifyData.claim_number = formData.claim_number
            }


            console.log('completeVerifyData:::: ',completeVerifyData)

            // if (isComplete) {
            //     await verifyHandler(completeVerifyData)
            // } 

            switch (folder) {
                case 'liabilities':
                    data = await addVerificationLiability(userToken, activeCase.case.id, itemId, reqBody)
                    break;
                case 'major_meds':
                    data = await addVerificationMajorMed(userToken, activeCase.case.id, itemId, reqBody)
                    break;
                case 'mp_pip_um':
                    reqBody.type = mpPipUmType
                    data = await addVerificationMedPayPipUm(userToken, activeCase.case.id, itemId, reqBody)
                    break;
            }

            if (data?.errorMessage) {
                dispatch(notificationActions.setError(data))
            } else {
                setIsModalOpened(false)

                dispatch(notificationActions.setError({errorMessage: `Verification added`, type: 'success'}))
                let dispatchBody = {
                    folder: folder,
                    field: verificationField,
                    itemId: itemId,
                    item: data?.history
                }
                dispatch(caseActions.addVerification(dispatchBody))
            }
        } finally {
            setIsLoading(false);
        }
    }

    function completeVerificationHandler(event) {
        setIsComplete(prevState => prevState = !prevState)
    }

    async function verifyHandler(formData) {
        let prefix = null
        switch (folder) {            
            case 'mp_pip_um':
                prefix = mpPipUmType + '_'
                break;
        }
        let today = formatDate(new Date())
        
        const reqBody = {
            type: caseType,
            type_id: itemId,
            fields: {
                [prefix ? prefix+'verified' : 'verified']: true,
                [prefix ? prefix+'verified_date' : 'verified_date']: today,
                [prefix ? prefix+'verified_by': 'verified_by']: user.name,
                [prefix ? prefix+'verified_spoke_to': 'verified_spoke_to']: formData.spoke_to,
            }    
        }

        if (folder != 'major_meds') {
            reqBody.fields[prefix ? prefix+'claim_number' : 'claim_number'] = formData.claim_number
        }

        const update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody, dispatch)
        

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        } else {
            let dispatchBody = {
                folder: folder,
                item: {
                    itemId: itemId,
                    fields: [
                        {
                            field: prefix ? prefix+'verified' : 'verified',
                            value: true
                        },
                        {
                            field:  prefix ? prefix+'verified_date' : 'verified_date',
                            value: today
                        },
                        {
                            field: prefix ? prefix+'verified_by': 'verified_by',
                            value: user.name
                        },
                        {
                            field: prefix ? prefix+'verified_spoke_to': 'verified_spoke_to',
                            value: formData.spoke_to
                        }
                    ]            
                }
            }

            if (folder != 'major_meds') {
                dispatchBody.item.fields.push({
                    field: prefix ? prefix+'claim_number': 'claim_number',
                    value: formData.claim_number
                })
            }

            setTimeout(() => {
                dispatch(caseActions.modifyActiveCaseMultiple(dispatchBody))
            }, 0)
        }

    }


    return (
        <>
            <Button click={addVerificationHandler} btnStyle={'btn_small'}>Add Verification</Button>
            {isModalOpened && <>
                {ReactDOM.createPortal(
                    <Backdrop hide={addVerificationHandler} />,
                    document.getElementById("backdrop-root")
                )}  
                {ReactDOM.createPortal(
                    <Modal>
                        <ModalInnerWrapper closeModal={addVerificationHandler} modalTitle={'Add Verification'}>
                            <PannelBody>
                                <form onSubmit={addVerification}>
                                    <div className="row">
                                        <InputBox label={'Spoke To'} name={'spoke_to'} required={true}/>
                                    </div>
                                    <div className="row">
                                        <TextareaBox label={'Notes'} name={'resolve_notes'} required={true}/>
                                    </div>
                                    {folder != 'major_meds' && <>
                                        <div className="row">
                                            <InputBox type={'text'} label={'Claim #'} name={'claim_number'} />
                                        </div>
                                    </>}
                                    <div className="row">
                                        <CustomSelect label='Status' name={'status'} optionsData={verificationStatusOptions()} required={true}/>
                                    </div>
                                    {errorMessage && <div className="row"><span className="danger">{errorMessage}</span></div>}
                                    {/* <div className="row flex-container">
                                        <CheckboxCell label={'Complete'} name={'complete'} required={true} direction={'reverse'} action={completeVerificationHandler} checked={isComplete}/>
                                        <GlobalTooltip>
                                            If checked Verification will be marked as completed and will not be able to be edited.
                                        </GlobalTooltip>
                                    </div> */}
                                    {/* {isComplete && folder != 'major_meds' && <>
                                        <div className="row">
                                            <InputBox label={'Claim #'} name={'claim_number'} required={true}/>
                                        </div>
                                    </>} */}
                                    <div className="row">
                                        <Button type={'submit'} isLoading={isLoading}>Add verification</Button>
                                    </div>
                                </form>
                            </PannelBody>
                        </ModalInnerWrapper>
                    </Modal>,
                    document.getElementById("overlay-root")
                )}          
            </>}
        </>
    )
}